// Lucide icon: plus (https://lucide.dev/icons/plus)
import { Plus } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconAdd = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Plus />
    </IconComponentStyled>
  )
}
